module.exports = __webpack_public_path__ + "static/walia-74a6d44199edfaeefdd968c5b2dfe5ad.jpg";